import { css } from '@/styled-system/css';

export const containerStyles = css({
  fontSize: 'md',
  lineHeight: 'md',
});

export const floorplanItemStyles = css({
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: '{colors.hpxGrey100}',
  _last: {
    borderBottomWidth: '0',
  },
});

export const expandStyles = css({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  paddingTop: '2x',
  paddingBottom: '1x',
  paddingLeft: '0',
  paddingRight: '0',
});

export const noticeWrapperStyles = css({
  marginBottom: '2x',
  paddingLeft: '2x',
  paddingRight: '2x',
});
